import script from "./CriteriaListPane.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriaListPane.vue?vue&type=script&setup=true&lang=js"

import "./CriteriaListPane.vue?vue&type=style&index=0&id=5b60f734&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b60f734"]])

export default __exports__